module.exports = __webpack_public_path__ + "static/media/Documents.72a06e2b.svg";